import Overlay from "../../components/overlays/TemplateOverlay";
import { BsThreeDots as Dots } from "react-icons/bs";

const Item = (props) => {
  // console.log(props.id);
  return (
    <article className="template-item">
      <div className="template-item-dots">
        <Dots style={{ color: "white", marginLeft: "12px" }}></Dots>
      </div>
      <div
        style={{
          backgroundColor: props.background,
          backgroundImage: `url(${props.image})`,
          backgroundSize: "cover",
          height: 230,
          width: "100%",
        }}
      />
      {/* <img src={props.image}></img> */}
      <Overlay
        previewUrl={props.previewUrl}
        showEdit={props.showEdit}
        id={props.id}
      />
      <p style={{ fontWeight: 600, marginTop: 16 }}>{props.nome}</p>
    </article>
  );
};

export default Item;
